import * as React from "react";
export var useHideBodyOverflow = function useHideBodyOverflow(hide) {
  React.useLayoutEffect(function () {
    if (hide) {
      document.body.style.overflow = "hidden";
    }
    return function () {
      document.body.style.overflow = "";
    };
  }, [hide]);
};